import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app-state/store';
import apiClient from '../../../canopy-ui-components/api';
import Filters from '../../../canopy-ui-components/components/Filters/DependentFilters/index';
import { filterOptions } from './FilterOptions';

function SimpleFilters({
    layoutState,
    setLayoutState,
    globalProps,
    selectedGroupBy,
    selectedGroupByFilters,
    setSelectedGroupBy,
    setSelectedGroupByFilters,
    setGroupBy,
    setGroupByFilters,
    groupBy,
    groupByFilters,
    setUserId,
    userId,
}: any) {
    const { user: loggedInUser, switchUser } = useSelector(
        (state: RootState) => state.auth
    );
    const [currentUser, setCurrentUser] = useState<Record<
        string,
        any
    > | null>();
    const [allUsers, setAllUsers] = useState<any>([]);

    const onApplyFilter = (
        filters: string[][] = [],
        groupBy: string[] = ['select-one']
    ) => {
        setSelectedGroupBy(groupBy);
        setSelectedGroupByFilters([...filters]);

        const otherFilters = filterOptions?.reduce((acc: any, item) => {
            if (item !== groupBy[0]) {
                acc[item] = null;
            }
            return acc;
        }, {});

        const filterParam: Record<string, any> = {};

        groupBy.forEach((item, index) => {
            filterParam[item] = filters[index] ? filters[index].join(',') : {};
        });

        setLayoutState(
            ({
                child_display_name,
                parent_display_name,
                ...layoutState
            }: any) => ({
                ...layoutState,
                ...otherFilters,
                ...filterParam,
                page: 1,
            })
        );
    };

    useEffect(() => {
        (async () => {
            try {
                if (!layoutState?.user_id && !currentUser?.id) {
                    return;
                }
                if (layoutState?.user_id && layoutState?.user_id === userId) {
                    return;
                }
                if (currentUser?.id && currentUser?.id === userId) {
                    return;
                }

                const newUserId = layoutState?.user_id || currentUser?.id;

                const params: any =
                    layoutState?.user_id !== 'all' && layoutState?.user_id
                        ? {
                              parent_user_ids: String(layoutState?.user_id),
                          }
                        : {};
                if (!layoutState?.user_id) {
                    params.is_partner_document = true;
                }

                const users = await apiClient.getFiltersChildAccounts('all');
                setAllUsers(users);
                setGroupBy([...filterOptions]);
                setSelectedGroupBy(['select-one']);

                const transformedFilters: Record<
                    string,
                    Record<string, string>[]
                > = {};

                const options: Record<string, any> = {};

                filterOptions.forEach((key: any) => (options[key] = {}));

                users.forEach((user: any) => {
                    if (!options['child-username'][user.childUsername]) {
                        options['child-username'][user.childUsername] = {
                            childDisplayName: user.childDisplayName,
                            childUserId: user.childUserId,
                            childUsername: user.childUsername,
                            parentUserIds: [user.parentUserId], // this needs to push in array as it's has multiple parents
                            parentUsernames: [user.parentUsername], // same for this too.
                        };
                    } else {
                        options['child-username'][
                            user.childUsername
                        ].parentUserIds.push(user.parentUserId);
                        options['child-username'][
                            user.childUsername
                        ].parentUsernames.push(user.parentUsername);
                    }
                    if (!options['parent-username'][user.parentUsername]) {
                        options['parent-username'][user.parentUsername] = {
                            parentDisplayName: user.parentDisplayName,
                            parentUserId: user.parentUserId,
                            parentUsername: user.parentUsername,
                            childrenArr: [user.childUsername],
                        };
                    } else {
                        options['parent-username'][
                            user.parentUsername
                        ].childrenArr.push(user.childUsername);
                    }
                });

                transformedFilters['parent-username'] = Object.keys(
                    options['parent-username']
                ).map((key: string) => ({
                    label: options['parent-username'][key]?.parentUsername,
                    value: options['parent-username'][key]?.parentUsername,
                    childArr: options['parent-username'][key]?.childrenArr,
                }));

                transformedFilters['child-username'] = Object.keys(
                    options['child-username']
                ).map((key: string) => {
                    return {
                        label: options['child-username'][key]?.childUsername,
                        value: options['child-username'][key]?.childUsername,
                        parentUserIds:
                            options['child-username'][key]?.parentUserIds,
                        parentUsernames:
                            options['child-username'][key]?.parentUsernames,
                    };
                });

                setGroupByFilters(transformedFilters);
                // setSelectedGroupByFilters([filterOptions[0]]);
                setUserId(newUserId);

                if (!globalProps?.qp?.group_by) {
                    setLayoutState((layoutState: any) => {
                        return {
                            ...layoutState,
                            group_by: filterOptions[0],
                            group_by_filters: '',
                        };
                    });
                }
            } catch (e) {
                console.log(e);
            }
        })();
    }, [layoutState?.user_id, currentUser]);

    useEffect(() => {
        if (
            loggedInUser?.role === 'Partneradmin' ||
            loggedInUser?.role === 'RelationshipManager'
        ) {
            setCurrentUser(loggedInUser);
        } else if (
            switchUser?.role === 'Partneradmin' ||
            switchUser?.role === 'RelationshipManager'
        ) {
            setCurrentUser(switchUser);
        }
    }, [loggedInUser, switchUser]);

    return (
        <Filters
            globalProps={globalProps}
            groupByFilters={groupByFilters}
            selectedGroupByFilters={selectedGroupByFilters}
            groupBy={groupBy}
            selectedGroupBy={selectedGroupBy}
            allowMultipleFilters={true}
            onApply={onApplyFilter}></Filters>
    );
}
export default SimpleFilters;
